import React from "react";
import axios from "axios";
import AutoComplete from "react-google-autocomplete";

const API_KEY = "AIzaSyAszDWe-iM4_DHCRYAFXvydZeg38xDChyk";
const COUNTRY = "us";

export default class Address extends React.Component<any, any> {
  state = null;

  constructor(props: any) {
    super(props);
    this.state = {
      searching: false,
    };
  }

  handlePlaceSelected = (place: any) => {
    const {
      apiKey = API_KEY,
      country = COUNTRY,
      onStartSearching,
      onFinishSearching,
      onValidateAddress,
    } = this.props;
    const data = {
      address: {
        regionCode: country,
        addressLines: [place.formatted_address],
      },
    };

    this.setState({ searching: true }, onStartSearching);
    axios
      .post(
        `https://addressvalidation.googleapis.com/v1:validateAddress?key=${apiKey}`,
        data,
      )
      .then(({ data: { result } }: any) => {
        const meta = {
          valid: result.verdict.addressComplete == true, // to handle undefined
          address: result.address.formattedAddress.split(",")[0],
          city: result.address.postalAddress?.locality,
          state: result.address.postalAddress?.administrativeArea,
          zip: result.address.postalAddress?.postalCode,
          latitude: result.geocode.location.latitude,
          longitude: result.geocode.location.longitude,
        };
        onValidateAddress(meta, result);
        this.setState({ searching: false }, onFinishSearching);
      })
      .catch(() => {
        this.setState({ searching: false }, onFinishSearching);
      });
  };

  render() {
    const { searching } = this.state;
    const {
      apiKey = API_KEY,
      country = COUNTRY,
      field,
      form,
      onStartSearching,
      onFinishSearching,
      onValidateAddress,
      ...props
    } = this.props;

    return (
      <>
        <AutoComplete
          apiKey={apiKey}
          id={field.name}
          options={{
            types: ["address"],
            componentRestrictions: { country },
          }}
          {...field}
          {...props}
          onPlaceSelected={this.handlePlaceSelected}
        />
        {searching && <img alt="searching" src="/images/loading.gif" />}
      </>
    );
  }
}
